import {
  ALL_PURCHASE_SUCCESS,
  LOAD_PURCHASE_FAIL,
  LOAD_PURCHASE_REQUEST,
} from "app/utils/constants/purchaseConstants";

const INIT_STATE = {
  loading: false,
  error: null,
  allPurchase: [],
  TotalPage: null,
};

export const purchaseReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOAD_PURCHASE_REQUEST:
      return {
        loading: true,
      };
    case ALL_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        allpurchase: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case LOAD_PURCHASE_FAIL:
      return {
        loading: false,
        allpurchase: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
